import * as ActionTypes from '@commonActionTypes'

export const updateTransportationDetails=({key,payload})=>{
        return{
            type:ActionTypes.UPDATE_TRANSPORT_DETAILS,
            key,
            payload
        }
    }
export const updateTransportationHeaderInfo=(payload)=>{
        return{
            type:ActionTypes.UPDATE_TRANSPORT_HEADER_INFO,
            payload
        }
    }

    export const initializeTransportForm =(payload)=>{
        return {
            type: ActionTypes.INITIALIZE_TRANSPORT_FORM,
            payload
        }
    }



